/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import * as yup from 'yup';

import { Zendesk as messages } from '../messages';

export const settingsSchema = yup.object().shape({
  private: yup.object().shape({
    secrets: yup
      .object()
      .shape({
        subscription: yup.object().shape({
          auth: yup.object().shape({
            private_token: yup.string()
          })
        })
      })
      .nullable()
      .default(undefined),
    subscription: yup.object().shape({
      auth: yup.object().shape({
        is_on: yup.boolean().default(false),
        authenticate_anonymous_users: yup.boolean().default(false)
      })
    })
  }),
  subscription: yup.object().shape({
    account: yup.object().shape({
      id: yup
        .string()
        .trim()
        .required(messages.connectAccountInvalid)
        .default('')
    })
  })
});

export const FIELDS = {
  ACCOUNT_CONNECTION_KEY: 'subscription.account.id',
  AUTHENTICATE_ANONYMOUS_USERS:
    'private.subscription.auth.authenticate_anonymous_users',
  AUTHENTICATION_ENABLED: 'private.subscription.auth.is_on',
  CLIENT_PRIVATE_TOKEN: 'private.secrets.subscription.auth.private_token'
};
